import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-16 px-4 bg-white" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-charcoal mb-8" data-id="element-106">
            ¿Te suena esto?
          </h2>

          <p className="font-medium" data-id="element-107">Son las 11 de la noche.</p>

          <p data-id="element-108">
            Mañana tenés un post-quirúrgico de LCA, un paciente con lumbalgia
            que no mejora y una primera consulta de un adulto mayor que se cayó
            dos veces este mes.
          </p>

          <p data-id="element-109">
            Abrís Google. Buscás en grupos de kines de WhatsApp. Encontrás un
            PDF en inglés que tenés que traducir y adaptar. Una hora después
            tenés algo.
          </p>

          <p data-id="element-110">No es lo que querías. Pero es lo que hay.</p>

          <p className="pt-4 font-medium text-brand-charcoal" data-id="element-111">
            Y lo peor no es el tiempo perdido.
          </p>

          <p className="font-medium text-brand-charcoal" data-id="element-112">
            Lo peor es llegar a esa sesión sin la seguridad de que lo que vas a
            hacer es exactamente lo correcto.
          </p>
        </motion.div>
      </div>
    </section>;
}